export const isPrivateExplanation =
    'Private boards are invite-only and cannot be shared publicly. Changing to private removes any current followers.';
export const isPublicExplanation =
    'Public boards can be shared with the general public and followed by users. External content cannot be uploaded to public boards.';
export const TITLE_MAX_LENGTH = 60;
export const TITLE_MIN_LENGTH = 3;
export const PRIVATE_TEXT_TOGGLE_FONT_SIZE = 16;
